import { useReports } from "../hooks/useReports.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Reports/shared/ReportTitles.tsx
var ReportTitles = ({ listAll = true, reportIds }) => {
	const { data, loading } = useReports({ idFilter: reportIds }, { cacheStrategy: "cache-only" });
	if (!data?.reports && loading) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 25 });
	if (!data?.reports || !reportIds?.length) return null;
	if (!listAll && data.total > 1) return /* @__PURE__ */ jsxs("div", {
		className: "flex min-w-0 shrink flex-nowrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: "truncate",
			children: data.reports[0].title
		}), /* @__PURE__ */ jsxs("span", {
			className: "text-info pl-xxs min-w-fit flex-1",
			children: ["+", data.total - 1]
		})]
	});
	return /* @__PURE__ */ jsx(Fragment$1, { children: data.reports.map(({ title }) => title).join(", ") });
};
//#endregion
export { ReportTitles };

//# sourceMappingURL=ReportTitles.js.map